(() => {
  const requestedWindow = new URLSearchParams(window.location.search).get('window');
  if (!requestedWindow) return;

  const values = {
    'rear-side': 'Rear Side Door Window',
    'back-windshield': 'Back Windshield',
    'front-windshield': 'Front Windshield',
  };

  const expected = values[requestedWindow];
  if (!expected) return;

  const selectWindow = () => {
    const controls = document.querySelectorAll(
      'variant-picker [data-option-name="Select Window"], variant-picker select[name*="Select Window"]'
    );

    for (const control of controls) {
      if (control.matches('input[type="radio"]') && control.value === expected) {
        if (!control.checked) control.click();
        control.closest('fieldset')?.scrollIntoView({ block: 'center' });
        return true;
      }

      if (control.matches('select')) {
        const option = Array.from(control.options).find((item) => item.value === expected);
        if (!option) continue;
        control.value = expected;
        control.dispatchEvent(new Event('change', { bubbles: true }));
        control.scrollIntoView({ block: 'center' });
        return true;
      }
    }

    return false;
  };

  if (selectWindow()) return;

  const observer = new MutationObserver(() => {
    if (!selectWindow()) return;
    observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 8000);
})();
